export default __webpack_public_path__ + "static/media/014-recipe book.b0972a8d.svg";